import NodeRSA from 'node-rsa';

// eslint-disable-next-line import/prefer-default-export
export const decodeRSA = (data) => {
  const key = new NodeRSA();
  const message = Buffer.from(data, 'base64');
  key.importKey(`-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAyZ9HewiwJGx5Kw6YwjN7
zGF6TV1Ym9r5hFAxAZ2qHzdpoAS1gamPa4yAfKB0DpDGyxRgz/tZpsUmYY73TtvC
c7p0FBjkP5GFq1eBdQiX4mgx8v3R4c7kkUBvoXHShxjfly9vdCLXGyAOBMrkmXZy
PHSjtInVbEMOsDdu3KxYTUkj5oD/sfRA5yyj5ZTX6cM2vaK4f2eejJnBmabKAnKT
mWTSKYnh1CgCDhX+9PJyceRVGy6mKFmS9AiTaEo7v3oIz29To+a5Zu2v5QM5NU5e
k+HbtEX2Qvan8PBdnPFxdBFsaXWKCF5DzHlCCJUnzMKaYOlM058fAprzBIt9QXJm
YQIDAQAB
-----END PUBLIC KEY-----`);
  const buf = key.decryptPublic(message);
  return buf.toString();
};
